// FCM remote push for Capacitor. Local sync alerts stay in offline/notifications.js (lion_sync).
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";

const CHANNEL_ID = "lion_push";
let listenersBound = false;
let currentToken = null;
let pendingLink = null;

const isAppPath = (link) => _.startsWith(link, "/") && !_.startsWith(link, "//");

const navigatePushLink = (link) => {
  if (!isAppPath(link)) return;
  const router = window.f7?.views?.main?.router;
  if (router) {
    router.navigate(link);
    return;
  }
  pendingLink = link;
};

export const consumePendingPushLink = () => {
  if (!pendingLink) return;
  const link = pendingLink;
  pendingLink = null;
  navigatePushLink(link);
};

const bindListeners = async () => {
  if (listenersBound) return;
  listenersBound = true;

  await PushNotifications.addListener("registration", async (token) => {
    currentToken = token?.value;
    if (!currentToken) return;
    try {
      await axios.post(
        "/auth/push_tokens.json",
        { token: currentToken, platform: Capacitor.getPlatform() },
        { skipOffline: true }
      );
    } catch (_e) {
      // offline / 401 — register() on next online boot retries
    }
  });

  await PushNotifications.addListener("pushNotificationActionPerformed", (event) => {
    const data = event?.notification?.data || {};
    navigatePushLink(data.link);
  });
};

export const registerPushNotifications = async () => {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await bindListeners();
    try {
      await PushNotifications.createChannel({
        id: CHANNEL_ID,
        name: "Alerts",
        description: "Lion notifications",
        importance: 4,
      });
    } catch (_e) {
      // channel may already exist
    }

    const current = await PushNotifications.checkPermissions();
    let receive = current.receive;
    if (receive !== "granted") {
      const requested = await PushNotifications.requestPermissions();
      receive = requested.receive;
    }
    if (receive !== "granted") return;

    await PushNotifications.register();
  } catch (_e) {
    // missing google-services.json / emulator without FCM
  }
};

export const unregisterPushNotifications = async () => {
  if (!currentToken) return;
  const token = currentToken;
  currentToken = null;
  try {
    await axios.delete("/auth/push_tokens.json", {
      data: { token },
      skipOffline: true,
      validateStatus: () => true,
    });
  } catch (_e) {
    // offline — token stays until FCM UNREGISTERED or next user upsert
  }
};
